export default __webpack_public_path__ + "static/media/6-100.ef05a756.jpg";